import React, { useCallback, useMemo } from 'react';
import MessageList from '~/ui/MessageList/MessageList';
import { connect } from '~/redux/connect';

/**
 * 
 * @param {object} props 
 * @property { boolean } props.requiresSelection
 * @property { string } props.actionName
 * @property { string } props.modelId
 * @property { number } props.rowCount
 * @property { string } props.modelTitle
 * @property { function } props.trans
 */
export const ActionMenuMessageList = connect()((props) => {
    const { trans, requiresSelection, rowCount, modelTitle, modelId, actionName} = props;

    const messageList = useMemo(() => {
        if (!props.requiresSelection) {
            return emptyMessages;
        }

        const transData = {
            count: rowCount,
            modelNamePlural: modelTitle
        }

        return [
            {
                message: trans('requiresSelection.message', transData),
                type: "info"
            }
        ];
    }, [
        requiresSelection,
        rowCount,
        modelTitle,
    ]);

    const filterMessages = useCallback((messages) => {
        return [...messageList,].concat(messages.filter(({tags}) => tags?.includes(actionName)))
    }, [messageList, actionName]);


    return <MessageList excludeMessageTags={excludeMessageTags} filterMessages={filterMessages} modelId={modelId} />
});

const emptyMessages = [];

const excludeMessageTags = [["grid-action", "customActionSuccess"]];